import { FieldType } from './DynamicField';

export function buildSchema(offer) {
    return [
        {
            label: 'Nazwa',
            path: 'name',
            type: FieldType.Text
        },
        {
            label: 'Cena',
            path: 'sellingMode.price.amount',
            type: FieldType.Text
        },
        {
            label: 'Szt. - ile sztuk produtku sprzedawanych jest w tej ofercie. ( *zazwyczaj jedna sztuka )',
            path: 'productSet[0].quantity.value',
            type: FieldType.Number
        },
        {
            label: 'Stan magazynowy - dostępna ilość produktów',
            path: 'stock.available',
            type: FieldType.Number
        },
        {
            label: 'Faktura',
            path: 'payments.invoice',
            type: FieldType.Select,
            options: [
                {
                    value: 'WITHOUT_VAT',
                    text: 'Bez VAT'
                },
                {
                    value: 'VAT',
                    text: 'VAT'
                },
                {
                    value: 'VAT_MARGIN',
                    text: 'VAT Marża'
                }
            ]
        },
        {
            label: 'Kategoria',
            path: 'category.id',
            type: FieldType.Text
        },
        {
            label: 'Dostawa',
            path: 'delivery.handlingTime',
            type: FieldType.Select,
            options: [
                {
                    value: 'PT24H',
                    text: 'Jeden dzień (24H)'
                },
                {
                    value: 'PT48H',
                    text: 'Dwa dni  (48H)'
                },
                {
                    value: 'PT72H',
                    text: 'Trzy dni (72H)'
                }
            ]
        },
        {
            label: 'Status oferty',
            path: 'publication.status',
            type: FieldType.Select,
            options: [
                { value: 'ACTIVE', text: 'Aktywna' },
                { value: 'INACTIVE', text: 'Nieaktywna' }
            ]
        },
        {
            label: 'Parametry',
            type: FieldType.Parameter,
            value: offer?.productSet?.[0]?.product?.parameters
        },
        {
            label: 'Opis',
            type: FieldType.Group,
            value: offer?.description?.sections
        },

    ];
}

export function buildSchemaForDesciption(offer) {
    return [
        // {
        //     label: 'Nazwa',
        //     path: 'name',
        //     type: FieldType.Text
        // },
        // {
        //     label: 'Cena',
        //     path: 'sellingMode.price.amount',
        //     type: FieldType.Number
        // },
        // {
        //     label: 'Stan magazynowy',
        //     path: 'stock.available',
        //     type: FieldType.Number
        // },
        // {
        //     label: 'Faktura',
        //     path: 'payments.invoice',
        //     type: FieldType.Select,
        //     options: [
        //         {
        //             value: 'WITHOUT_VAT',
        //             text: 'Bez VAT'
        //         },
        //         {
        //             value: 'VAT',
        //             text: 'VAT'
        //         },
        //         {
        //             value: 'VAT_MARGIN',
        //             text: 'VAT Marża'
        //         }
        //     ]
        // },
        // {
        //     label: 'Dostawa',
        //     path: 'delivery.handlingTime',
        //     type: FieldType.Text
        // },
        // {
        //     label: 'Status oferty',
        //     path: 'publication.status',
        //     type: FieldType.Select,
        //     options: [
        //         { value: 'ACTIVE', text: 'Aktywna' },
        //         { value: 'INACTIVE', text: 'Nieaktywna' }
        //     ]
        // },
        // {
        //     label: 'Parametry',
        //     type: FieldType.Parameter,
        //     value: offer?.productSet?.[0]?.product?.parameters
        // },
        {
            label: 'Opis',
            type: FieldType.Group,
            value: offer?.description?.sections
        },

    ];
}